import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './serviceWorker';
import { StoreProvider } from './store/index';
import 'normalize.css'
ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
